// extracted by mini-css-extract-plugin
export default {"Button":"index-module__Button__yhXE37f","Box":"index-module__Box__L1rXjL1","NavList":"index-module__NavList__kgLrOFm"};